<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == "ven-tipo-agenda") {
            next({ name: "ven-tipo-agenda-list" });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == "ven-tipo-agenda") {
            this.$router.push({ name: "ven-tipo-agenda-list" });
        }
    },
};
</script>